module.exports = __webpack_public_path__ + "static/media/googlecloudlogo.0bad9ff3.png";